<template>
<div class="chapter">
<div class="inner_page">
<div class="forward">
<h1>Acknowledgments</h1>
<p><span><b>FIRST</b>, I’d like to thank my family for planting deep the roots of responsibility, independent thinking, and affection for nature. They, and their support for my career, continue to help me deliver on the Lean and Green promise.</span></p>
<p><span>Thanks to Takako Kawakami for help with research in Japan, Joseph Letterman for his contributions to the research questionnaire, and Rebecca Wilson for her administrative assistance and encouragement.</span></p>
<p><span>For their patience during my travels to research the book—and doing well without me—I thank the consultants and support staff of Technology Forecasters, Inc. Thanks go to the author Dr. Eric Maisel; my agent, Linda Allen; and my publisher, Steven Piersanti, for their help in shaping the book to reach every employee in every organization.</span></p>
<p><span>I appreciate—boundlessly—the love and support from my husband, Yosaif Solove. Finally, thanks and admiration go to the Lean and Green champions featured in this book, who combine optimism and pragmatism to achieve outstanding results for their organizations and the planet.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub_9781605094076_3.vue?a461ad3c